class BlogList extends HTMLElement {
  constructor() {
    super();
    this.initDataTabs();
  }

  initDataTabs() {
    this.setupQuestions();
    this.setupDropdownToggle();
    this.setupDropdownItems();
    this.setupTabs();
    this.setupSearch();
  }

  setupDropdownToggle() {
    const dropdownBtn = document.querySelector('[data-dropdown-btn]');
    const blogList = document.querySelector('[data-blog-list]');
    dropdownBtn.addEventListener('click', () => {
      blogList.classList.toggle('blogs-list__list--active');
    });
  }

  setupDropdownItems() {
    const dropdownBtn = document.querySelector('[data-dropdown-btn]');
    const blogListItems = document.querySelectorAll('[data-blog-list-item]');
    dropdownBtn.setAttribute('data-value-btn', 'all');
    blogListItems.forEach(item => {
      item.addEventListener('click', () => {
        const itemValue = item.getAttribute('data-value');
        dropdownBtn.querySelector('span').textContent = item.textContent;
        dropdownBtn.setAttribute('data-value-btn', itemValue);
        document.querySelector('[data-blog-list]').classList.toggle('blogs-list__list--active');
      });
    });
  }

  setupTabs() {
    const tabs = document.querySelectorAll("[data-tab]");
    const tabsContent = document.querySelectorAll("[data-content]");
    const faq = document.querySelector("[data-description]");
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        this.activateTab(tab, tabs, tabsContent, faq);
      });
    });
  }

  activateTab(selectedTab, tabs, tabsContent, faq) {
    // Reset active states for tabs and content
    tabs.forEach(tab => tab.classList.remove('blogs-list__title--active'));
    tabsContent.forEach(content => content.classList.remove('blogs-list__content-container--active'));
  
    // Activate the selected tab and its corresponding content
    const content = selectedTab.getAttribute('data-tab');
    selectedTab.classList.add('blogs-list__title--active');
    document.querySelector(`[data-${content}]`).classList.add('blogs-list__content-container--active');
    
    // Toggle FAQ description visibility
    faq.classList.toggle("blogs-list__faq-description--active", content === "faq");
  
    // Reset search input and dropdown filter
    this.resetSearchAndFilters();
  }
  
  resetSearchAndFilters() {
    const searchInput = document.querySelector('[data-search]');
    const dropdownBtn = document.querySelector('[data-dropdown-btn]');
    const blogListItems = document.querySelectorAll('[data-blog-title]');
    const blogListItemsMob = document.querySelectorAll('[data-blog-title-mob]');
    const desktopFilter = document.querySelector('[data-desktop-filter]');
    const mobileFilter = document.querySelector('[data-mobile-filter]');
    const listHidden = document.querySelector('[data-list-hidden]');
    const listHiddenMob = document.querySelector('[data-list-hidden-mob]');
    const pagination = document.querySelector('[data-pagination]');
    const noResult = document.querySelector('[data-no-result]');
  
    // Clear the search input
    searchInput.value = '';
  
    // Reset the dropdown to 'all'
    dropdownBtn.querySelector('span').textContent = 'All';
    dropdownBtn.setAttribute('data-value-btn', 'all');
  
    // Show all blog items and reset filters
    blogListItems.forEach(item => item.style.display = 'flex');
    blogListItemsMob.forEach(item => item.style.display = 'flex');
    if(window.innerWidth > 1023) {
      desktopFilter.style.display = 'block';
      mobileFilter.style.display = 'none';
    }
    else {
      desktopFilter.style.display = 'none';
      mobileFilter.style.display = 'block';
    }
    listHidden.style.display = 'none';
    listHiddenMob.style.display = 'none';
  
    if (pagination) {
      pagination.style.display = 'block';
    }
  
    // Hide the no result message
    noResult.style.display = 'none';
  }
  

  setupQuestions() {
    const questions = document.querySelectorAll('[data-question]');
    questions.forEach(question => {
      question.addEventListener('click', () => {
        this.toggleQuestion(question);
      });
    });
  }

  toggleQuestion(selectedQuestion) {
    const questionNumber = selectedQuestion.getAttribute('data-question');
    const answer = document.querySelector(`[data-answer="${questionNumber}"]`);
    const isActive = answer.classList.contains('blogs-list__answer-wrapper--active');

    if (isActive) {
      answer.style.maxHeight = null;
      answer.classList.remove('blogs-list__answer-wrapper--active');
      document.querySelector(`[data-question-open="${questionNumber}"]`).classList.remove('blogs-list__img-open--active');
      document.querySelector(`[data-question-close="${questionNumber}"]`).style.display = "block";
    } else {
      this.closeAllQuestions();
      answer.style.maxHeight = answer.scrollHeight + 'px';
      answer.classList.add('blogs-list__answer-wrapper--active');
      document.querySelector(`[data-question-open="${questionNumber}"]`).classList.add('blogs-list__img-open--active');
      document.querySelector(`[data-question-close="${questionNumber}"]`).style.display = "none";
    }
  }

  closeAllQuestions() {
    document.querySelectorAll('[data-question-open]').forEach(open => {
      open.classList.remove('blogs-list__img-open--active');
    });

    document.querySelectorAll('[data-question-close]').forEach(close => {
      close.style.display = "block";
    });

    document.querySelectorAll('[data-answer]').forEach(answer => {
      answer.style.maxHeight = null;
      answer.classList.remove('blogs-list__answer-wrapper--active');
    });
  }

  setupSearch() {
    const searchBtn = document.querySelector('[data-search-btn]');
    const searchInput = document.querySelector('[data-search]');
    const blogListItems = document.querySelectorAll('[data-blog-title]');
    const blogListItemsMob = document.querySelectorAll('[data-blog-title-mob]');
    const desktopFilter = document.querySelector('[data-desktop-filter]');
    const mobileFilter = document.querySelector('[data-mobile-filter]');
    const listHidden = document.querySelector('[data-list-hidden]');
    const listHiddenMob = document.querySelector('[data-list-hidden-mob]');
    const pagination = document.querySelector('[data-pagination]');
    const noResult = document.querySelector('[data-no-result]');

    const searchHandler = (items, filter, hiddenList) => {
      const query = searchInput.value.toLowerCase();
      const dateRange = this.getDateRange();

      let resultsFound = false;

      items.forEach(item => {
        const itemText = item.getAttribute(items === blogListItems ? 'data-blog-title' : 'data-blog-title-mob').toLowerCase();
        const itemDate = new Date(item.getAttribute('data-blog-date'));

        if (query == "") {
          filter.style.display = 'block';
          hiddenList.style.display = 'none';
          if(pagination) {
            pagination.style.display = 'block';
          }
        }
        else if(this.matchesSearchQuery(itemText, query) && this.matchesDateRange(itemDate, dateRange)) {
          item.style.display = 'flex';
          filter.style.display = 'none';
          hiddenList.style.display = 'block';
          if(pagination) {
            pagination.style.display = 'none';
          }
          resultsFound = true;
          console.log("found")
        } else {
          item.style.display = 'none';
          filter.style.display = 'none';
          if(pagination) {
            pagination.style.display = 'none';
          }
          console.log("not-found")
        }
      });

      noResult.style.display = resultsFound || query === '' ? 'none' : 'flex';
    };

    searchBtn.addEventListener('click', () => {
      if (window.innerWidth > 1023) {
        searchHandler(blogListItems, desktopFilter, listHidden);
      } else {
        searchHandler(blogListItemsMob, mobileFilter, listHiddenMob);
      }
    });
  }

  matchesSearchQuery(itemText, query) {
    return query === '' || itemText.includes(query);
  }

  matchesDateRange(itemDate, dateRange) {
    const now = new Date();
    if (dateRange === 'all') return true;
    if (dateRange === 'week') return itemDate >= new Date(now.setDate(now.getDate() - 7));
    if (dateRange === 'month') return itemDate >= new Date(now.setMonth(now.getMonth() - 1));
    if (dateRange === 'three-months') return itemDate >= new Date(now.setMonth(now.getMonth() - 3));
    return false;
  }

  getDateRange() {
    const dropdownBtn = document.querySelector('[data-dropdown-btn]');
    const selectedDateRange = dropdownBtn.getAttribute('data-value-btn');
    return selectedDateRange;
  }
}

customElements.define('blog-list', BlogList);